
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DOWNLOAD_CLIENT_TYPE } from '../constant';
import { DownloadUrls, So360DownloadCallbackData } from '../config/types';
import Footer from '../components/Footer.vue';
import PcVideoSection from './PcVideoSection.vue';
import { collectDownload } from '@/config/collect';
import { downloadAndroidApp, downloadIosApp } from '../utils/appDownload';
import { downloadResolvedFile } from '../utils/resolveDownloadUrl';

@Component({
  components: { Footer, PcVideoSection },
})
export default class PcVideoOnlyPage extends Vue {
  @Prop({ required: true }) public downloadUrls!: DownloadUrls;
  @Prop({ required: true }) public videoSrc!: string;
  @Prop({ default: false }) public showIosDownload!: boolean;
  @Prop({ default: false }) public showAppInfo!: boolean;
  @Prop({ default: false }) public isBaiduDeveloper!: boolean;
  @Prop({ default: true }) public showAddress!: boolean;
  @Prop({ default: '' }) public developerName!: string;
  @Prop({ default: '' }) public baiduApiToken!: string;
  @Prop() public so360DownloadConfig?: So360DownloadCallbackData;
  @Prop() public byDownloadConfig?: So360DownloadCallbackData;

  public downloadClientType = DOWNLOAD_CLIENT_TYPE;

  public handleDownload(type: string) {
    if (type === DOWNLOAD_CLIENT_TYPE.IOS) {
      downloadIosApp({ iosDownloadUrl: '', iosAppKey: '' });
      return;
    }
    if (!this.downloadUrls[type][process.env.NODE_ENV]) {
      return;
    }
    if (type === DOWNLOAD_CLIENT_TYPE.ANDROID) {
      downloadAndroidApp(this.downloadUrls);
      return;
    }
    const rawUrl = this.downloadUrls[type][process.env.NODE_ENV];
    downloadResolvedFile(rawUrl, type, {
      baiduApiToken: this.baiduApiToken,
      so360DownloadConfig: this.so360DownloadConfig,
      byDownloadConfig: this.byDownloadConfig,
      query: (this as any).$route.query,
    });
  }
}
